export default __webpack_public_path__ + "static/media/jazy.35e3b6a5.jpg";